import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::importFile
* @see app/Http/Controllers/Investors/EstateObjectsController.php:175
* @route '//app.finesthub.de/properties/import-file'
*/
export const importFile = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: importFile.url(options),
    method: 'post',
})

importFile.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/properties/import-file',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::importFile
* @see app/Http/Controllers/Investors/EstateObjectsController.php:175
* @route '//app.finesthub.de/properties/import-file'
*/
importFile.url = (options?: RouteQueryOptions) => {
    return importFile.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::importFile
* @see app/Http/Controllers/Investors/EstateObjectsController.php:175
* @route '//app.finesthub.de/properties/import-file'
*/
importFile.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: importFile.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::create
* @see app/Http/Controllers/Investors/EstateObjectsController.php:74
* @route '//app.finesthub.de/properties/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/properties/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::create
* @see app/Http/Controllers/Investors/EstateObjectsController.php:74
* @route '//app.finesthub.de/properties/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::create
* @see app/Http/Controllers/Investors/EstateObjectsController.php:74
* @route '//app.finesthub.de/properties/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::create
* @see app/Http/Controllers/Investors/EstateObjectsController.php:74
* @route '//app.finesthub.de/properties/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::storeBasics
* @see app/Http/Controllers/Investors/EstateObjectsController.php:111
* @route '//app.finesthub.de/properties/create'
*/
export const storeBasics = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: storeBasics.url(options),
    method: 'post',
})

storeBasics.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/properties/create',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::storeBasics
* @see app/Http/Controllers/Investors/EstateObjectsController.php:111
* @route '//app.finesthub.de/properties/create'
*/
storeBasics.url = (options?: RouteQueryOptions) => {
    return storeBasics.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::storeBasics
* @see app/Http/Controllers/Investors/EstateObjectsController.php:111
* @route '//app.finesthub.de/properties/create'
*/
storeBasics.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: storeBasics.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::index
* @see app/Http/Controllers/Investors/EstateObjectsController.php:35
* @route '//app.finesthub.de/properties'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/properties',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::index
* @see app/Http/Controllers/Investors/EstateObjectsController.php:35
* @route '//app.finesthub.de/properties'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::index
* @see app/Http/Controllers/Investors/EstateObjectsController.php:35
* @route '//app.finesthub.de/properties'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::index
* @see app/Http/Controllers/Investors/EstateObjectsController.php:35
* @route '//app.finesthub.de/properties'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::store
* @see app/Http/Controllers/Investors/EstateObjectsController.php:150
* @route '//app.finesthub.de/properties'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/properties',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::store
* @see app/Http/Controllers/Investors/EstateObjectsController.php:150
* @route '//app.finesthub.de/properties'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::store
* @see app/Http/Controllers/Investors/EstateObjectsController.php:150
* @route '//app.finesthub.de/properties'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::show
* @see app/Http/Controllers/Investors/EstateObjectsController.php:67
* @route '//app.finesthub.de/properties/{estateObject}'
*/
export const show = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/properties/{estateObject}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::show
* @see app/Http/Controllers/Investors/EstateObjectsController.php:67
* @route '//app.finesthub.de/properties/{estateObject}'
*/
show.url = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { estateObject: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { estateObject: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: typeof args.estateObject === 'object'
        ? args.estateObject.id
        : args.estateObject,
    }

    return show.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::show
* @see app/Http/Controllers/Investors/EstateObjectsController.php:67
* @route '//app.finesthub.de/properties/{estateObject}'
*/
show.get = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::show
* @see app/Http/Controllers/Investors/EstateObjectsController.php:67
* @route '//app.finesthub.de/properties/{estateObject}'
*/
show.head = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::edit
* @see app/Http/Controllers/Investors/EstateObjectsController.php:211
* @route '//app.finesthub.de/properties/{estateObject}/edit'
*/
export const edit = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/properties/{estateObject}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::edit
* @see app/Http/Controllers/Investors/EstateObjectsController.php:211
* @route '//app.finesthub.de/properties/{estateObject}/edit'
*/
edit.url = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { estateObject: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { estateObject: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: typeof args.estateObject === 'object'
        ? args.estateObject.id
        : args.estateObject,
    }

    return edit.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::edit
* @see app/Http/Controllers/Investors/EstateObjectsController.php:211
* @route '//app.finesthub.de/properties/{estateObject}/edit'
*/
edit.get = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::edit
* @see app/Http/Controllers/Investors/EstateObjectsController.php:211
* @route '//app.finesthub.de/properties/{estateObject}/edit'
*/
edit.head = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::update
* @see app/Http/Controllers/Investors/EstateObjectsController.php:218
* @route '//app.finesthub.de/properties/{estateObject}'
*/
export const update = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '//app.finesthub.de/properties/{estateObject}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::update
* @see app/Http/Controllers/Investors/EstateObjectsController.php:218
* @route '//app.finesthub.de/properties/{estateObject}'
*/
update.url = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { estateObject: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { estateObject: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: typeof args.estateObject === 'object'
        ? args.estateObject.id
        : args.estateObject,
    }

    return update.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::update
* @see app/Http/Controllers/Investors/EstateObjectsController.php:218
* @route '//app.finesthub.de/properties/{estateObject}'
*/
update.put = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::update
* @see app/Http/Controllers/Investors/EstateObjectsController.php:218
* @route '//app.finesthub.de/properties/{estateObject}'
*/
update.patch = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::destroy
* @see app/Http/Controllers/Investors/EstateObjectsController.php:276
* @route '//app.finesthub.de/properties/{estateObject}'
*/
export const destroy = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/properties/{estateObject}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::destroy
* @see app/Http/Controllers/Investors/EstateObjectsController.php:276
* @route '//app.finesthub.de/properties/{estateObject}'
*/
destroy.url = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { estateObject: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { estateObject: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: typeof args.estateObject === 'object'
        ? args.estateObject.id
        : args.estateObject,
    }

    return destroy.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\EstateObjectsController::destroy
* @see app/Http/Controllers/Investors/EstateObjectsController.php:276
* @route '//app.finesthub.de/properties/{estateObject}'
*/
destroy.delete = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const EstateObjectsController = { importFile, create, storeBasics, index, store, show, edit, update, destroy }

export default EstateObjectsController